export default "/images/d83c1aa9f1d83ea1b9cc04098274281f.avif";